<template>
	<!-- 监理发文 -->
	<div class="mod-config">
		<!-- <el-col :span="1" style="border:1px solid transparent"></el-col> -->
		<el-col :span="24">
			<el-card body-style="padding-bottom: 0;">
				<el-row class="title_color">
					<el-col :span="20">
						<div class="title">{{ fileKindName }}</div>
					</el-col>
					<el-col :span="4" style="margin-top:10px;margin-bottom:-10px">
						<i class="el-icon-sort" id="PointerIcon" style="right:1rem;transform:rotate(90deg);" @click="goBack()"></i>
						<el-button v-preventReClick type="text" @click="goBack()" class="backbtn">返回门户</el-button>
					</el-col>
				</el-row>
				<div class="line"></div>
				<el-row
					style="margin-top: -8px;margin-left: -20px;line-height:30px;width: 103%;background-color: rgb(243, 247, 247)">
					<el-row style="margin-top: 10px;">
						<el-col :span="2">
							<div class="search_title">标的物</div>
						</el-col>
						<el-col :span="22" style="display: flex;flex-wrap: wrap;">
							<span v-for="(subject, index) in subjectList" style="margin-right: 50px;">
								<span class="search_bn_border" v-if="form.subjectNo === subject.displayValue"
									@click="setSubject(subject)">
									{{ subject.displayName }}
								</span>
								<span class="search_bn" v-else-if="form.subjectNo !== subject.displayValue"
									@click="setSubject(subject)">
									{{ subject.displayName }}
								</span>
							</span>
						</el-col>
					</el-row>
					<el-form ref="form" :model="form" inline label-width="80px" label-position="left" v-if="closeState != '0'">
						<el-row class="set_search">
							<el-col :span="17" style="margin-left:35px">
								<el-form-item label="文件编号" class="selFormItem">
									<el-input class="selSearchInput" v-model="form.fileNo" clearable></el-input>
								</el-form-item>
								<el-form-item label="封闭状态" class="selFormItem" v-if="closeState != '0'">
									<el-select class="selMajorInput" v-model="form.closeFlg" placeholder="请选择" clearable>
										<el-option v-for="item in closeFlgList" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="签发时间" class="selFormItem" style="margin-top:2px">
									<el-date-picker class="selDateInput" v-model="dispTime" type="daterange"
										value-format="yyyy-MM-dd" range-separator="~" start-placeholder="开始日期"
										end-placeholder="结束日期" clearable>
									</el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-button style="margin-top:5px" v-preventReClick class="btn" type="primary" size="small"
									@click="selGetDataList()">查询</el-button>
								<el-button v-preventReClick class="rebtn" size="small" @click="resetFormData()">重置</el-button>
								<div style="float: right;margin-right: 15px;vertical-align:middle;margin-top:6px">
									<span style="font-size: 16px; font-weight: bold;vertical-align: middle">已封闭 </span>
									<el-tag size="medium" type="success" style="font-size: 16px">{{ dataTotal.closeNum }} 份</el-tag>
									<span style="font-size: 16px; font-weight: bold;vertical-align: middle">未封闭 </span>
									<el-tag size="medium" type="danger" style="font-size: 16px;">{{ dataTotal.nonCloseNum }}
										份</el-tag>
								</div>
							</el-col>
						</el-row>
					</el-form>
					<el-form ref="form" :model="form" inline label-width="80px" label-position="left" v-else>
						<el-row class="set_search">
							<el-col :span="18" style="margin-left:35px">
								<el-form-item label="文件编号" class="selFormItem">
									<el-input class="selSearchInput" v-model="form.fileNo" clearable></el-input>
								</el-form-item>
								<el-form-item label="封闭状态" class="selFormItem" v-if="closeState != '0'">
									<el-select class="selMajorInput" v-model="form.closeFlg" placeholder="请选择" clearable>
										<el-option v-for="item in closeFlgList" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="签发时间" class="selFormItem" style="margin-top:2px">
									<el-date-picker class="selDateInput" v-model="dispTime" type="daterange"
										value-format="yyyy-MM-dd" range-separator="~" start-placeholder="开始日期"
										end-placeholder="结束日期" clearable>
									</el-date-picker>
								</el-form-item>
								</el-col>
								<el-col :span="4" class="selBtnGroup">
								<el-button style="margin-top:5px" v-preventReClick class="btn" type="primary" size="small"
									@click="selGetDataList()">查询</el-button>
								<el-button v-preventReClick class="rebtn" size="small" @click="resetFormData()">重置</el-button>
							</el-col>
						</el-row>
					</el-form>
				</el-row>
			</el-card>
			<div v-if="closeState === '0'">
				<el-card style="margin-top: -25px;" body-style="padding: 0;">
					<el-row style=" margin-bottom: 10px;">
						<el-col :span="24">
							<div class="box">
								<el-table :height="screenHeight - 195 + 'px'" :row-style="selectRowBackground" class="dataListTable" :data="dataList"
									header-align="center" style="width: 100%; margin-bottom: 10px;" border
									:row-class-name="tableRowClassName" header-cell-class-name="dataListTHeader"
									:cell-style="{ padding: '0px' }">
									<el-table-column label="NO." type="index" width="60" align="center" fixed="left">
										<template slot-scope="scope">{{ (pageIndex2 - 1) * pageSize + scope.$index + 1
										}}</template>
									</el-table-column>
									<el-table-column prop="fileNo" label="文件编号" width="180" align="center" fixed="left">
										<template slot-scope="scope">
											<el-button v-preventReClick type="text" size="small"
											@click="viewPdf(scope.row.finalFilePath, scope.row.finalFilePathUri, scope.row.fileNo)">{{
												scope.row.fileNo }}</el-button>
										</template>
									</el-table-column>
									<!-- <el-table-column prop="dispObject" label="发文对象" align="left" show-overflow-tooltip>
									</el-table-column> -->
									<el-table-column prop="fileTitle" label="主要内容概述" align="left" show-overflow-tooltip>
									</el-table-column>
									<el-table-column prop="dispTime" label="签发时间" width="120" align="center">
									</el-table-column>
									<!-- <el-table-column prop="dispMan" label="工程师 " width="110" align="center">
									</el-table-column> -->
									<el-table-column prop="closeTime" label="封闭时间 " width="110" align="center">
									</el-table-column>
									<el-table-column prop="closeMan" label="封闭人" width="120" align="center">
									</el-table-column>
									<el-table-column prop="remark" label="备注" width="120" align="center" show-overflow-tooltip>
									</el-table-column>
									<el-table-column label="操作" width="120" align="center" fixed="right">
										<template slot-scope="scope">
											<el-button v-preventReClick type="text" size="small"
												@click="downloadFile(scope.row.finalFilePathUri, scope.row.fileName)"
												v-if="scope.row.finalFilePathUri">下载</el-button>
										</template>
									</el-table-column>
								</el-table>
							</div>
							<el-pagination class="my-pagination" @size-change="sizeChangeHandle"
								@current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50, 100]"
								:page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
							</el-pagination>
						</el-col>
					</el-row>
				</el-card>
			</div>
			<div v-if="closeState != '0'">
				<el-card style="margin-top: -25px;" body-style="padding: 0;">
					<el-row style="margin-bottom: 10px;">
						<el-col :span="24">
							<div class="box">
								<el-table :height="screenHeight - 195 + 'px'" :row-style="selectRowBackground" class="dataListTable" :data="dataList"
									header-align="center" style="width: 100%; margin-bottom: 10px;" border
									:row-class-name="tableRowClassName" header-cell-class-name="dataListTHeader"
									:cell-style="{ padding: '0px' }">
									<el-table-column label="NO." type="index" width="60" align="center" fixed="left">
										<template slot-scope="scope">{{ (pageIndex2 - 1) * pageSize + scope.$index + 1
										}}</template>
									</el-table-column>
									<el-table-column prop="fileNo" label="文件编号" width="180" align="center" fixed="left">
										<template slot-scope="scope">
											<el-button v-preventReClick type="text" size="small"
											@click="viewPdf(scope.row.finalFilePath, scope.row.finalFilePathUri, scope.row.fileName)">{{
												scope.row.fileNo }}</el-button>
										</template>
									</el-table-column>
									<!-- <el-table-column prop="dispObject" label="发文对象" align="left" show-overflow-tooltip>
									</el-table-column> -->
									<el-table-column prop="fileTitle" label="主要内容概述" align="left" show-overflow-tooltip>
									</el-table-column>
									<el-table-column prop="dispTime" label="签发时间" width="120" align="center">
									</el-table-column>
									<!-- <el-table-column prop="dispMan" label="工程师 " width="110" align="center">
									</el-table-column> -->
									<el-table-column prop="closeTime" label="封闭时间 " width="110" align="center">
									</el-table-column>
									<el-table-column prop="closeMan" label="封闭人" width="120" align="center">
									</el-table-column>
									<el-table-column prop="remark" label="备注" width="120" align="center" show-overflow-tooltip>
									</el-table-column>
									<el-table-column label="操作" width="120" align="center" fixed="right">
										<template slot-scope="scope">
											<el-button v-preventReClick type="text" size="small"
												@click="downloadFile(scope.row.finalFilePathUri, scope.row.fileName)"
												v-if="scope.row.finalFilePathUri">下载</el-button>
										</template>
									</el-table-column>
								</el-table>
							</div>
							<el-pagination class="my-pagination" @size-change="sizeChangeHandle"
								@current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50, 100]"
								:page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
							</el-pagination>
						</el-col>
					</el-row>
				</el-card>
			</div>
		</el-col>
		<view-pdf v-if="viewPdfVisible" ref="viewPdf" @refreshDataList="dataList"></view-pdf>
	</div>
</template>
<script>
import $common from "@/utils/common.js"
import ViewPdf from "../projectInfo/viewPdf.vue"
export default {
	data() {
		return {
			viewPdfVisible: false,
			pdfVisible: false,
			showSearch: true,
			showFileKindSet: true,
			showReply: true,
			showAdd: true,
			showEdit: true,
			showDelete: true,
			showCheck: true,
			showArchive: true,
			showDownload: true,
			pageSpan: 12,
			tabIndex: "0",
			addOrUpdateVisible: false,
			auditVisible: false,
			closeVisible: false,
			closeFileVisible: false,
			disabledBatchDelete: true,
			filesViewVisible: false,
			dataTotal: {
				closeNum: 0,
				nonCloseNum: 0
			},
			form: {
				closeFlg: '',
				subjectNo: '',
				fileNo: ''
			},
			closeFlgList: [
				{
					label: '未封闭',
					value: '0'
				}, {
					label: '已封闭',
					value: '1'
				}
			],
			fileKindName: '',
			documentTypeList: [],
			fileNo: "",
			fileTitle: "",
			dispMan: "",
			dispTime: [],
			deceDispCompany: "",
			exaFlg: "",
			answerFinishFlg: "",
			answerFinishFlgName: "",
			dataList: [],
			//当前页码
			pageIndex: 1,
			// 显示序号
			pageIndex2: 1,
			//当前记录数
			pageSize: 20,
			//总页数
			totalPage: 0,
			tableSelVal: [],
			subjectList: [],
			uploadFileId: '',
			uploadContactVisible: false,
			uploadFile : {
				uploadFilePath : '',
				uploadFileUri: '',
				uploadFileName: ''
			},
			closeState: '',
			screenHeight: 0
		};
	},
	components: {
		ViewPdf
	},
	mounted() {
		this.screenHeight = window.innerHeight
		this.fileKindName = '监理联系单'
		this.closeState = this.$route.query.closeState;
		// 未封闭数据
		if(this.closeState === '0') {
			this.form.closeFlg = '0'
			this.fileKindName = '未封闭的监理联系单'
		}

		this.getSubjectDropDown();
	},
	methods: {
		getSubjectDropDown() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/index/getSubjectDropDown/" + $common.getItem("workNo"),
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.code === 200) {
					this.subjectList = data.body;
					if (this.subjectList != undefined && this.subjectList.length > 0) {
						this.form.subjectNo = this.subjectList[0].displayValue
						this.getDataList();
					}
				}
			});
		},
		setSubject(subject) {
			this.form.subjectNo = subject.displayValue
			this.getDataList()
		},
		viewPdf(filePath, fileUri, filename) {
			// pdf和doc文件，需要pdf在线预览，其他类型文件直接下载
			let suffixType = fileUri.substr(fileUri.lastIndexOf(".") + 1)
			if(suffixType != '' && (suffixType === 'pdf' || suffixType === 'doc' || suffixType === 'docx')) {
				// $common.viewFile(filePath)
				this.viewPdfVisible = true;
				this.$nextTick(() => {
					this.$refs.viewPdf.init(filename, filePath)
				})
			} else {
				filename = this.getSuffix(fileUri, filename)
				this.getBlob(fileUri, (blob) => {
					this.saveAs(blob, filename)
				})
			}
		},
		downloadFile(fileUri, filename) {
			filename = this.getSuffix(fileUri, filename)
			this.getBlob(fileUri, (blob) => {
				this.saveAs(blob, filename)
			})
		},
		countContact() {
			let startTime;
			let completeTime;
			if (this.dispTime != null) {
				startTime = this.dispTime[0] ? this.dispTime[0] : ""
				completeTime = this.dispTime[1] ? this.dispTime[1] : ""
			} else {
				startTime = ""
				completeTime = ""
			}
			this.$http({
				url: this.$store.state.httpUrl + "/business/supervisioncontactinfo/countContact",
				method: 'get',
				params: this.$http.adornParams({
					startTime: startTime,
					completeTime: completeTime,
					workNo: $common.getItem("workNo"),
					subjectNo: this.form.subjectNo,
					fileNo: this.form.fileNo,
					closeFlg: this.form.closeFlg,
				})
			}).then(({ data }) => {
				if (data && data.code === 200) {
					this.dataTotal = data.body
				}
			})
		},
		// 获取数据列表
		getDataList() {
			let startTime;
			let completeTime;
			if (this.dispTime != null) {
				startTime = this.dispTime[0] ? this.dispTime[0] : ""
				completeTime = this.dispTime[1] ? this.dispTime[1] : ""
			} else {
				startTime = ""
				completeTime = ""
			}
			this.countContact();
			this.$http({
				url: this.$store.state.httpUrl + "/business/supervisioncontactinfo/list",
				method: 'get',
				params: this.$http.adornParams({
					page: this.pageIndex,
					limit: this.pageSize,
					startTime: startTime,
					completeTime: completeTime,
					workNo: $common.getItem("workNo"),
					subjectNo: this.form.subjectNo,
					closeFlg: this.form.closeFlg,
					fileNo: this.form.fileNo,
					executedFileType: '1'
				})
			}).then(({ data }) => {
				if (data && data.code === 200) {
					this.dataList = data.body.records;
					this.totalPage = data.body.totalCount;
					this.pageIndex2 = this.pageIndex
				} else {
					this.dataList = []
					this.totalPage = 0
					this.pageIndex2 = 1
				}
			})
		},
		//搜索
		selGetDataList() {
			this.pageIndex = 1;
			this.getDataList();
		},
		//重置
		resetFormData() {
			this.dispTime = [];
			this.form.closeFlg = '';
			// this.form.subjectNo = '';
			this.form.fileNo = '';
			this.getDataList();
		},
		// 每页数
		sizeChangeHandle(val) {
			this.pageSize = val
			this.pageIndex = 1
			this.getDataList()
		},
		// 当前页
		currentChangeHandle(val) {
			this.pageIndex = val
			this.getDataList()
		},
		tableRowClassName({ row, rowIndex }) {
			return $common.tableRowClassName({ row, rowIndex });
		},
		selectRowBackground({ row }) {
			const checkIdList = this.tableSelVal.map((item) => item.fileId);
			if (checkIdList.includes(row.fileId)) {
				return {
					backgroundColor: "#fae8cb",
				};
			}
		},
		extractFileName(fileName) {
            let index = fileName.lastIndexOf(".");
            return fileName.substr(0, index)
        },
        getSuffix(url, filename) {
            let lastIndex = url.lastIndexOf(".");
            return filename + url.substr(lastIndex)
        },
        getBlob(url, cb) {
            var xhr = new XMLHttpRequest()
            xhr.open('GET', url, true)
            xhr.responseType = 'blob'
            xhr.onload = function () {
                if (xhr.status === 200) {
                    cb(xhr.response)
                }
            }
            xhr.send()
        },
        saveAs(blob, filename) {
            if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, filename)
            }
            else {
                var link = document.createElement('a')
                var body = document.querySelector('body')

                link.href = window.URL.createObjectURL(blob)
                link.download = filename

                link.style.display = 'none'
                body.appendChild(link)

                link.click()
                body.removeChild(link)
                window.URL.revokeObjectURL(link.href)
            }
        },
		goBack() {
			this.$router.push({ name: 'workbench' });
		}
	}
};
</script>
<style lang="scss" scoped="scoped">
.selItemText {
	font-size: 14px;
	color: #1c1c1c;
	display: inline-block;
	width: 80px;
}

::v-deep(.el-table .cellgrey) {
	background: #d6e0eb !important;
	;
}

.my-pagination {
	margin-left: 20px !important;
}

// 设置表头样式
::v-deep(.el-table th.el-table__cell) {
	// background-color: #d3e2f4 !important;
	font-size: 15px;
	padding: 2px 0;
}

::v-deep(.selSubjectInput .el-input__inner) {
	width: 120px !important;
	height: 30px !important;
}

::v-deep(.selSearchInput .el-input__inner) {
	width: 150px !important;
	height: 30px !important;
}

::v-deep(.selMajorInput .el-input__inner) {
	width: 110px !important;
	height: 30px !important;
}

.selDateInput {
	width: 280px !important;
	margin-top: 2px;
	height: 32px;

	::v-deep .el-input__inner {
		height: 33px;
	}
}

::v-deep(.selDateInput .el-range-separator) {
	width: 40px !important;
	margin-top: -8px;
}

::v-deep(.selFormItem .el-form-item__label) {
	font-size: smaller;
}

::v-deep(.upload-demo .el-upload-dragger) {
	width: 200px;
	height: 80px;
}

::v-deep(.upload-demo .el-upload-dragger .el-icon-upload) {
	font-size: 30px;
	margin: 12px 1px;
	line-height: 20px;
}

::v-deep(.upload-demo .el-upload-dragger .el-upload__text) {
	line-height: 5px;
}

.item {
	color: #00428E !important;
	margin-right: 10px !important;
	font-weight: bold !important;
	background-color: #E1F1FF;
	white-space: nowrap !important;
	border: solid #dadada 1px;
	height: 35px !important;
	text-align: center;
	padding-top: 8px
}
</style>
